/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getDiscriminatedUnionDecoder,
  getDiscriminatedUnionEncoder,
  getStructDecoder,
  getStructEncoder,
  getTupleDecoder,
  getTupleEncoder,
  getU32Decoder,
  getU32Encoder,
  getUnitDecoder,
  getUnitEncoder,
  type Codec,
  type Decoder,
  type Encoder,
  type GetDiscriminatedUnionVariant,
  type GetDiscriminatedUnionVariantContent,
} from '@solana/kit';
import {
  getMetaDecoder,
  getMetaEncoder,
  getStakeDecoder,
  getStakeEncoder,
  getStakeFlagsDecoder,
  getStakeFlagsEncoder,
  type Meta,
  type MetaArgs,
  type Stake,
  type StakeArgs,
  type StakeFlags,
  type StakeFlagsArgs,
} from '.';

export type StakeStateV2 =
  | { __kind: 'Uninitialized' }
  | { __kind: 'Initialized'; fields: readonly [Meta] }
  | { __kind: 'Stake'; fields: readonly [Meta, Stake, StakeFlags] }
  | { __kind: 'RewardsPool' };

export type StakeStateV2Args =
  | { __kind: 'Uninitialized' }
  | { __kind: 'Initialized'; fields: readonly [MetaArgs] }
  | { __kind: 'Stake'; fields: readonly [MetaArgs, StakeArgs, StakeFlagsArgs] }
  | { __kind: 'RewardsPool' };

export function getStakeStateV2Encoder(): Encoder<StakeStateV2Args> {
  return getDiscriminatedUnionEncoder(
    [
      ['Uninitialized', getUnitEncoder()],
      [
        'Initialized',
        getStructEncoder([['fields', getTupleEncoder([getMetaEncoder()])]]),
      ],
      [
        'Stake',
        getStructEncoder([
          [
            'fields',
            getTupleEncoder([
              getMetaEncoder(),
              getStakeEncoder(),
              getStakeFlagsEncoder(),
            ]),
          ],
        ]),
      ],
      ['RewardsPool', getUnitEncoder()],
    ],
    { size: getU32Encoder() }
  );
}

export function getStakeStateV2Decoder(): Decoder<StakeStateV2> {
  return getDiscriminatedUnionDecoder(
    [
      ['Uninitialized', getUnitDecoder()],
      [
        'Initialized',
        getStructDecoder([['fields', getTupleDecoder([getMetaDecoder()])]]),
      ],
      [
        'Stake',
        getStructDecoder([
          [
            'fields',
            getTupleDecoder([
              getMetaDecoder(),
              getStakeDecoder(),
              getStakeFlagsDecoder(),
            ]),
          ],
        ]),
      ],
      ['RewardsPool', getUnitDecoder()],
    ],
    { size: getU32Decoder() }
  );
}

export function getStakeStateV2Codec(): Codec<StakeStateV2Args, StakeStateV2> {
  return combineCodec(getStakeStateV2Encoder(), getStakeStateV2Decoder());
}

// Data Enum Helpers.
export function stakeStateV2(
  kind: 'Uninitialized'
): GetDiscriminatedUnionVariant<StakeStateV2Args, '__kind', 'Uninitialized'>;
export function stakeStateV2(
  kind: 'Initialized',
  data: GetDiscriminatedUnionVariantContent<
    StakeStateV2Args,
    '__kind',
    'Initialized'
  >['fields']
): GetDiscriminatedUnionVariant<StakeStateV2Args, '__kind', 'Initialized'>;
export function stakeStateV2(
  kind: 'Stake',
  data: GetDiscriminatedUnionVariantContent<
    StakeStateV2Args,
    '__kind',
    'Stake'
  >['fields']
): GetDiscriminatedUnionVariant<StakeStateV2Args, '__kind', 'Stake'>;
export function stakeStateV2(
  kind: 'RewardsPool'
): GetDiscriminatedUnionVariant<StakeStateV2Args, '__kind', 'RewardsPool'>;
export function stakeStateV2<K extends StakeStateV2Args['__kind'], Data>(
  kind: K,
  data?: Data
) {
  return Array.isArray(data)
    ? { __kind: kind, fields: data }
    : { __kind: kind, ...(data ?? {}) };
}

export function isStakeStateV2<K extends StakeStateV2['__kind']>(
  kind: K,
  value: StakeStateV2
): value is StakeStateV2 & { __kind: K } {
  return value.__kind === kind;
}
